export default "__VITE_PUBLIC_ASSET__b62e8a5b__"